import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getInfoMessage, dismissInfoMessage } from 'ducks/layout';
import { e2e } from 'utils/queryUtils';
import Toast from 'components/Toast/Toast';
import { useAppDispatch } from 'ducks/hooks';

const InfoMessage = () => {
  const dispatch = useAppDispatch();
  const infoMessage = useSelector(getInfoMessage);

  const dismiss = useCallback(() => {
    dispatch(dismissInfoMessage());
  }, [dispatch]);

  useEffect(() => {
    if (infoMessage) {
      setTimeout(() => dismiss(), 8000);
    }
  }, [infoMessage, dismiss]);

  return (
    <>
      {!e2e() && infoMessage && (
        <Toast visible={!!infoMessage} onClose={dismiss} toastMessage={infoMessage} />
      )}
    </>
  );
};

export default InfoMessage;
